<template>

  <div class="all-stats-wrapper">

<div class="stat-wrapper">
  <h3 class="stat-row-headline">7,142 completions for 80,358 Yards (REG SEASON)</h3>
      <div class="stat-row stat-row-label">
      <div class="stat-col">Player</div>
      <div class="stat-col">Receptions</div>
      <div class="stat-col">Yards</div>
    </div>
    <div class="stat-row" v-for="player in RegSeasonReceiversData">
      <div class="stat-col">{{player.Player}}</div>
      <div class="stat-col">{{player.Receptions}}</div>
      <div class="stat-col">{{player.Yards}}</div>
    </div>
</div>

<div class="stat-wrapper">
  <h3 class="stat-row-headline">462 completions for 5,232 Yards (PLAYOFFS)</h3>
    <div class="stat-row stat-row-label">
      <div class="stat-col">Player</div>
      <div class="stat-col">Receptions</div>
      <div class="stat-col">Yards</div>
    </div>
    <div class="stat-row" v-for="player in PostSeasonReceiversData">
      <div class="stat-col">{{player.Player}}</div>
      <div class="stat-col">{{player.Receptions}}</div>
      <div class="stat-col">{{player.Yards}}</div>
    </div>
</div>

<div class="stat-wrapper">
  <h3  class="stat-row-headline">Regular Season Touchdowns</h3>
    <div class="stat-row stat-row-label">
      <div class="stat-col">Player</div>
      <div class="stat-col">Touchdowns</div>
    </div>
    <div class="stat-row" v-for="player in RegularSeasonTDs">
      <div class="stat-col">{{player.Player}}</div>
      <div class="stat-col">{{player.TDs}}</div>
    </div>
</div>

<div class="stat-wrapper">
  <h3 class="stat-row-headline">Post Season Touchdowns</h3>
    <div class="stat-row stat-row-label">
      <div class="stat-col">Player</div>
      <div class="stat-col">Touchdowns</div>
    </div>
    <div class="stat-row" v-for="player in PostSeasonTDs">
      <div class="stat-col">{{player.Player}}</div>
      <div class="stat-col">{{player.TDs}}</div>
    </div>
</div>


</div>
</template>

<script>

import axios from 'axios';

export default {
  name: 'RegSeasonReceivers',
  data: function () {
    return {
      RegSeasonReceiversData: [],
      PostSeasonReceiversData: [],
      RegularSeasonTDs: [],
      PostSeasonTDs: []
  }
  },
  methods: {

  },
  mounted(){
 
 axios.get('../../static/RegularSeasonReceivers.json').then(response => (
        this.RegSeasonReceiversData = response.data,
        console.log(this.RegSeasonReceiversData, "Mounted returns the RegSeasonReceiver")
        ))

 axios.get('../../static/PostSeasonReceivers.json').then(response => (
        this.PostSeasonReceiversData = response.data,
        console.log(this.PostSeasonReceiversData, "Mounted returns the RegSeasonReceiver")
        ))

  axios.get('../../static/RegularSeasonTDs.json').then(response => (
        this.RegularSeasonTDs = response.data,
        console.log(this.RegularSeasonTDs, "Mounted returns the RegSeasonReceiver")
        ))

 axios.get('../../static/PostSeasonTDs.json').then(response => (
        this.PostSeasonTDs = response.data,
        console.log(this.PostSeasonTDs, "Mounted returns the RegSeasonReceiver")
        ))

}
}

</script>

<style>
.all-stats-wrapper {
  display:flex;
  justify-content: space-around;
}

.stat-wrapper {
  color:white;
  width:24%;
      display: flex;
    flex-direction: column;
    height: 100%;
    border: 2px solid white;
    margin-top:20px;
}

.stat-row {
    display: flex;
    border-bottom: 2px solid white;
    padding: 5px 0px;
    font-size: 14px;
}

.stat-row:last-of-type {
    border-bottom: none;
}


.stat-row-headline {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height:60px;
  padding:5px;
  margin:0px;
  font-family: 'Teko', sans-serif;
    text-transform: uppercase;
    line-height: 21px;
}

.stat-row.stat-row-label {
    padding-top: 3px;
    background: white;
    padding: 0px;
    padding-top: 6px;
}

.stat-row-label > .stat-col {
  background:white;
  color:black;
  font-size: 20px;
  font-weight: bold;
  font-family: 'Teko', sans-serif;
  text-transform: uppercase;
}

.stat-col {
flex: 1;
font-family: 'Poppins', sans-serif;
display: flex;
    justify-content: center;
    align-items: center;
}

.stat-col:nth-of-type(1) {
flex: 2;
}



@media (max-width:1024px) {
.stat-col {
    line-height: 15px;
}

.stat-row-label > .stat-col {
    font-size: 14px;
}
}



@media (max-width:1023px) {
  .all-stats-wrapper {
  flex-wrap:wrap;
}

.stat-wrapper {
  width:45%;

}

}

@media (max-width:600px) {

.stat-wrapper {
  width:98%;
}
}


@media (max-width:420px) {
  .stat-row {
    border-bottom: 1px solid white;
    padding: 2px 0px;
    font-size: 12px;
}


}

</style>


// WEBPACK FOOTER //
// src/components/RegSeasonReceivers.vue